import React, { useCallback } from 'react';
import Button from '~/src/components/Button';
import analyticsService from '~/src/services/analytics';

type DocumentCompletedItemProps = {
  template: {
    id: number;
    title: string;
    ms_word_template: string;
  };
  templateName: string;
};

const DocumentCompletedItem = ({
  template,
  templateName,
}: DocumentCompletedItemProps) => {
  const trackViewInWordClick = useCallback(() => {
    analyticsService.track('Drafting Specialist - Clicked on Review in Word', {
      template_id: template.id,
    });
  }, [template.id]);

  return (
    <div className="rounded-lg border border-gray-200 h-14">
      <div className="flex justify-between items-center gap-4 h-full px-4">
        <div className="flex-1 text-sm text-gray-900 break-words">
          {templateName}
        </div>
        <div className="flex-shrink-0">
          <a href={template.ms_word_template} onClick={trackViewInWordClick}>
            <Button
              primary
              className="normal-case h-8 text-xs font-medium"
              data-pendo-id="Draft-AI-Review-template"
            >
              Review in Word
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default DocumentCompletedItem;
